import type { ChaveDePeriodo } from '@dv/domain'
import type { Traducao } from '../textos.ts'

/** Só apresentação: as chaves, ordem e datas continuam no calendário do domínio. */
export const TEXTOS_DO_PERIODO = {
  periodo: { 'pt-BR': 'Período', 'es-419': 'Período', 'en-US': 'Period' },
  todasAsDatas: { 'pt-BR': 'Todas as datas', 'es-419': 'Todas las fechas', 'en-US': 'All dates' },
  hoje: { 'pt-BR': 'Hoje', 'es-419': 'Hoy', 'en-US': 'Today' },
  esta_semana: { 'pt-BR': 'Esta semana', 'es-419': 'Esta semana', 'en-US': 'This week' },
  este_mes: { 'pt-BR': 'Este mês', 'es-419': 'Este mes', 'en-US': 'This month' },
  mes_passado: { 'pt-BR': 'Mês passado', 'es-419': 'Mes pasado', 'en-US': 'Last month' },
  este_trimestre: { 'pt-BR': 'Este trimestre', 'es-419': 'Este trimestre', 'en-US': 'This quarter' },
  trimestre_passado: { 'pt-BR': 'Trimestre passado', 'es-419': 'Trimestre pasado', 'en-US': 'Last quarter' },
  ytd: { 'pt-BR': 'Ano até hoje (YTD)', 'es-419': 'Año hasta hoy (YTD)', 'en-US': 'Year to date (YTD)' },
  ultimos_12_meses: { 'pt-BR': 'Últimos 12 meses', 'es-419': 'Últimos 12 meses', 'en-US': 'Last 12 months' },
  ano_2026: { 'pt-BR': '2026', 'es-419': '2026', 'en-US': '2026' },
  personalizado: { 'pt-BR': 'Personalizado…', 'es-419': 'Personalizado…', 'en-US': 'Custom…' },
  inicio: { 'pt-BR': 'Data inicial', 'es-419': 'Fecha inicial', 'en-US': 'Start date' },
  fim: { 'pt-BR': 'Data final', 'es-419': 'Fecha final', 'en-US': 'End date' },
  de: { 'pt-BR': 'De', 'es-419': 'Desde', 'en-US': 'From' },
  ate: { 'pt-BR': 'Até', 'es-419': 'Hasta', 'en-US': 'To' },
  aplicar: { 'pt-BR': 'Aplicar', 'es-419': 'Aplicar', 'en-US': 'Apply' },
  intervaloInvalido: {
    'pt-BR': 'Informe uma data final igual ou posterior à inicial.',
    'es-419': 'Indica una fecha final igual o posterior a la inicial.',
    'en-US': 'Enter an end date on or after the start date.',
  },
} satisfies Readonly<Record<ChaveDePeriodo | 'periodo' | 'todasAsDatas' | 'inicio' | 'fim' | 'de' | 'ate' | 'aplicar' | 'intervaloInvalido', Traducao>>

export const TEXTOS_DOS_ESTADOS = {
  carregando: { 'pt-BR': 'Carregando…', 'es-419': 'Cargando…', 'en-US': 'Loading…' },
  erro: { 'pt-BR': 'Não foi possível carregar', 'es-419': 'No se pudo cargar', 'en-US': 'Could not load' },
  retry: { 'pt-BR': 'Tentar novamente', 'es-419': 'Intentar de nuevo', 'en-US': 'Try again' },
} satisfies Readonly<Record<string, Traducao>>
